import React from 'react'

export class GoogleAnalytics extends React.Component {
  /**
   * When the component is mounted
   */
  componentDidMount() {
    // Disabled while I figure out why it does not load.
    // const script = document.createElement('script')
    // script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-127063412-1'
    // script.async = true
    // document.body.appendChild(script)
    // window.dataLayer = window.dataLayer || []
    // function gtag() {
    //   window.dataLayer.push(arguments)
    // }
    // gtag('js', new Date())
    // gtag('config', 'UA-127063412-1')
  }

  /**
   * Does not render anything.
   * Just a substitute for the original script.
   * @override
   */
  render() {
    return null
  }
}
